export const ACADEMY_WELCOME_URL = "https://onestep.co/welcome/academy";
